/**
 * Import da biblioteca "styled-components", que permite escrever
 * CSS simples para os componentes sem acontecer conflitos com os
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

export const WrapModal = styled.div`
  cursor: all-scroll;
  position: absolute;
  background: #1F2D4D;
  border-radius: 8px;
  width: 748px;
  height: 72px;
  z-index: 1700;
  display: flex;
  align-items: center;

  .divLeft {
    display: flex;
    margin-bottom: 4px;
  }

  .divRight {
    display: flex;
  }

  .divLoading {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .divIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #475371;
    svg {
      font-size: 48px;
    }
  }

  .divYear {
    button {
      width: 24px;
      font-size: 20px;
      height: unset !important;
      background: none;

      &:hover {
        background-color: #284280;
        border: none;
      }
      &:disabled {
        background-color: #2c3e50;
        color: #6C7A92;
        cursor: not-allowed;
      }
    }

    span {
      font-size: 18px;
      color: #BEC7DC;
    }
  }

  .divMonths {
    margin-left: 4px;
    display: flex;
    gap: 2px;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;

    button {
      height: 28px !important;
      margin: 0px;
      &:hover {
        background-color: #284280;
        border: none;  
      }

      &.selected {
        background-color: #284280;
        color: #ffffff;
        border: none;
      }

      &:disabled {
        background-color: #2c3e50;
        color: #6C7A92;
        cursor: not-allowed;
      }
    }
  }

  .divMosaicCurrent {
    border-left: 1px solid #475371;
    margin-left: 8px;
    padding-left: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: 11px;
    color: #BEC7DC;
  }
`
